import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { useTranslation } from '@lt/localization';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import { scrollToFlights } from 'checkout/utils/globalUtils';
import { goToFlightSectionAction } from '../../../store/actions/view';
import {
  getOrderFlightIsBusiness,
  getSelectedFlightData,
} from '../../../store/selectors/order';
import { getIsHomePath } from '../../../store/selectors/router';

import FlightsItemSidebar from '../../../CheckoutRoutes/PackageCheckout/components/Flights/FlightsItemSidebar';
import FlightsPropTypes from '../../../CheckoutRoutes/PackageCheckout/proptypes/flights';

const changedCls = 'checkout-flight-changed';

const SidebarFlight = ({
  className,
  goToFlightAction,
  flightData,
  isHomePath,
  isBusinessFlight,
  isMobile,
  isDateChangable,
}) => {
  const { t } = useTranslation();
  const goToFlight = isHomePath ? scrollToFlights : goToFlightAction;

  return (
    <div
      className={classNames(className, {
        [changedCls]: !flightData,
      })}
    >
      {!flightData && (
        <div className={`${changedCls}__text`}>
          <strong>{`${t('checkout.sidebar.flightChanged.title')}!`}</strong>
          <span>{` ${t('checkout.sidebar.flightChanged.searcher')}...`}</span>
        </div>
      )}
      {flightData && (
        <FlightsItemSidebar
          to={flightData.to}
          back={flightData.back[0]}
          onClick={goToFlight}
          isBusinessFlight={isBusinessFlight}
          isMobile={isMobile}
          isDateChangable={isDateChangable}
        />
      )}
    </div>
  );
};

SidebarFlight.defaultProps = {
  className: null,
  isBusinessFlight: false,
};

SidebarFlight.propTypes = {
  className: PropTypes.string,
  flightData: PropTypes.shape({
    to: FlightsPropTypes.to,
    back: FlightsPropTypes.back,
  }).isRequired,
  isHomePath: PropTypes.bool.isRequired,
  goToFlightAction: PropTypes.func.isRequired,
  isBusinessFlight: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const flightData = getSelectedFlightData(state);

  return {
    flightData,
    isDateChangable: flightData.isChangable,
    isHomePath: getIsHomePath(state),
    isBusinessFlight: getOrderFlightIsBusiness(state),
    isMobile: getIsMobile(state),
    isHotelOnly: getIsHotelOnly(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  goToFlightAction: () => dispatch(goToFlightSectionAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarFlight);
